import React, {useState} from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import DatePicker, { registerLocale } from 'react-datepicker';
import {sortArrayByProperty} from 'helpers/array-helper';
import {localizationData} from 'data/localization-data';
import {adminUiTexts} from 'data/ui-texts';
import './stats.scss';

const Stats = ({users}) => {
	/* Start and end dates */
	const [startDate, setStartDate] = useState(dayjs().startOf('week').add(1, 'day').format('YYYYMMDD'));
	const [endDate, setEndDate] = useState(dayjs().endOf('week').add(1, 'day').format('YYYYMMDD'));


	
	/* Localize dates */
	registerLocale('da', {
		localize: {
			month: (n) => {return localizationData.months[n];},
			day: (n) => {return localizationData.days[n];}
		}, 
		formatLong:{
			date: () => {return 'yyyy-mm-dd';}
		} 
	});


	const goBack1Week = () => {
		setStartDate(dayjs(startDate).subtract(1, 'week').format('YYYYMMDD'));
		setEndDate(dayjs(endDate).subtract(1, 'week').format('YYYYMMDD'));
	};

	const goForward1Week = () => {
		setStartDate(dayjs(startDate).add(1, 'week').format('YYYYMMDD'));
		setEndDate(dayjs(endDate).add(1, 'week').format('YYYYMMDD'));
	};



	const createdUsersInPeriod = users.filter((u) => {
		return (dayjs(u.created).format('YYYYMMDD') >= startDate && dayjs(u.created).format('YYYYMMDD') <= endDate);
	});
	const loggedInUsersInPeriod = users.filter((u) => {
		return (dayjs(u.lastLogin).format('YYYYMMDD') >= startDate && dayjs(u.lastLogin).format('YYYYMMDD') <= endDate);
	});


	/* Sort by date desc */
	const usersSortedByCreationDates = sortArrayByProperty(users, 'created', 'DESC');
	const usersSortedByLoginDates = sortArrayByProperty(users, 'lastLogin', 'DESC');

	return (
		<div className="Stats">

			<div className="Stats-periodStats">

				<div className="Stats-period">
					<div className="Stats-periodBtn" onClick={goBack1Week} />	
					<DatePicker
						disabled={false}
						selected={startDate ? dayjs(startDate).toDate() : new Date()}
						onChange={(date) => {setStartDate(dayjs(date).format('YYYYMMDD'));}}
						locale={'da'}
						dateFormat="dd/MM-yyyy"
						placeholderText="dd/MM-yyyy"
					/>
					<div className="Stats-periodTo"><span>{adminUiTexts.to}</span></div>
					<DatePicker
						disabled={false}
						selected={endDate ? dayjs(endDate).toDate() : new Date()}
						onChange={(date) => {setEndDate(dayjs(date).format('YYYYMMDD'));}}
						locale={'da'}
						dateFormat="dd/MM-yyyy"
						placeholderText="dd/MM-yyyy"
					/>
					<div className="Stats-periodBtn" onClick={goForward1Week} />
				</div>

				<div className="Stats-created">
					<div className="Stats-title">{adminUiTexts.created}:</div>
					<div className="Stats-number">{createdUsersInPeriod.length}</div>
				</div>

				<div className="Stats-loggedIn">
					<div className="Stats-title">{adminUiTexts.loggedIn}:</div>
					<div className="Stats-number">{loggedInUsersInPeriod.length}</div>
				</div>

			</div>



			{/* Last 5 created and logged in */}
			<div className="Stats-createdAndLoginDates">
				<div className="Stats-createdDates">
					<div className="Stats-title">{adminUiTexts.last} {adminUiTexts.created.toLowerCase()}:</div>
					<div className="Stats-dates">
						{usersSortedByCreationDates.map((user, index) => {
							return (
								<div key={index} className="Stats-date">
									<span>{dayjs(user.created).format('DD/MM/YYYY')}</span>
									<span>{user.email}</span>
								</div>
							);
						})}
					</div>
				</div>

				<div className="Stats-loginDates">
					<div className="Stats-title">{adminUiTexts.last} {adminUiTexts.loggedIn.toLowerCase()}:</div>
					<div className="Stats-dates">
						{usersSortedByLoginDates.map((user, index) => {
							return (
								<div key={index} className="Stats-date">
									<span>{dayjs(user.lastLogin).format('DD/MM/YYYY')}</span>
									<span>{user.email}</span>
								</div>
							);
						})}
					</div>
				</div>
			</div>

		
		</div>
	);
};

Stats.propTypes = {
	users: PropTypes.array.isRequired
};

export default Stats;
